import { render, staticRenderFns } from "./Step4AnswerQuestions.vue?vue&type=template&id=354ea136&scoped=true&"
import script from "./Step4AnswerQuestions.vue?vue&type=script&lang=js&"
export * from "./Step4AnswerQuestions.vue?vue&type=script&lang=js&"
import style0 from "./Step4AnswerQuestions.vue?vue&type=style&index=0&id=354ea136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ea136",
  null
  
)

export default component.exports